<template>
  <nav @keydown.esc="$store.commit('setMobileMenuOpen', false)" tabindex="0">
    <div class="small-header">
      <div class="hide-mobile"></div>
      <span>Moved by balance</span>
      <div>
        <a href="https://www.xsensible.com/english/community/">
          Community
        </a>
      </div>
    </div>
    <div class="nav-container">
      <div class="left">
        <a
          v-for="(link, i) in links"
          :key="i"
          :href="link.link"
          target="_blank"
          class="link"
        >
          {{ link.name }}
        </a>
      </div>
      <Hamburger :is-open="$store.state.isMobileMenuOpen" class="hamburger" />
      <a class="logo" href="https://www.xsensible.com" target="_blank">
        <img alt="Xsensible Logo" src="../assets/images/logo.svg" />
      </a>
    </div>
    <MobileMenu :is-open="$store.state.isMobileMenuOpen" />
  </nav>
</template>

<script>
import MobileMenu from '@/components/MobileMenu'
import Hamburger from '@/components/Hamburger'

export default {
  name: 'Header',
  components: { Hamburger, MobileMenu },
  data() {
    return {
      links: [
        { name: 'Hiking', link: 'https://www.xsensible.com/english/hiking' },
        {
          name: 'New',
          link: 'https://www.xsensible.com/english/new/our-ss20-collection.html'
        },
        { name: 'Women', link: 'https://www.xsensible.com/english/women/' },
        { name: 'Men', link: 'https://www.xsensible.com/english/men/' },
        {
          name: 'Store Locator',
          link: 'https://www.xsensible.com/english/store-locator/'
        },
        {
          name: 'Stories',
          link: 'https://www.xsensible.com/english/our-story/stories/'
        },
        {
          name: 'Our Story',
          link: 'https://www.xsensible.com/english/our-story/'
        }
      ],
      isOpen: false
    }
  },
  computed: {
    showSidebar() {
      return this.$route.meta.requiresAuth
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
  border-bottom: 1px solid #f6f6f5;
  position: fixed;
  width: 100%;
  z-index: 10;
  outline: none;

  .nav-container {
    display: flex;
    height: 90px;
    padding: 0 136px;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    background-color: white;

    .hamburger {
      @media screen and (min-width: 1366px) {
        display: none;
      }
    }

    .left {
      justify-self: start;
      flex: 0 1 40%;

      .link {
        &:first-child {
          color: orange;
        }

        :not(:last-child) {
          margin-right: 4px;
        }
      }

      @media screen and (max-width: 1365px) {
        display: none;
      }
    }

    .logo {
      height: 60px;
      justify-content: center;
      display: flex;
      flex: 0 1 19%;
    }

    .link {
      padding: 5px;
      text-decoration: none;
      margin-bottom: 4px;
      color: black;
    }

    @media screen and (max-width: 1365px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      justify-content: center;
    }

    @media screen and (max-width: 1706px) {
      padding: 0 30px;
    }
  }

  .small-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    background-color: #f1f1f1;
    padding: 10px 50px 10px 0;

    div {
      &:last-child {
        justify-self: end;
      }

      a {
        margin-right: 10px;
        color: black;
        text-decoration: none;

        &:hover {
          color: #7f7f7f;
          text-decoration: underline;
        }
      }
    }

    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
